import * as React from "react";
import { forwardRef } from "react";

var CrossOutline = function CrossOutline(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8.632 10.01L0 1.376 1.359.017 9.98 8.641 18.619 0l1.316 1.316-8.637 8.638L20 18.658 18.658 20l-8.693-8.696-8.648 8.65L.004 18.64l8.628-8.63"
  }));
};

var ForwardRef = /*#__PURE__*/forwardRef(CrossOutline);
export default ForwardRef;